var t = function t(_t, o) {
    return {
      x: Math.max(0, _t.left - o.left) + Math.max(0, o.right - _t.right) === 0,
      y: Math.max(0, _t.top - o.top) + Math.max(0, o.bottom - _t.bottom) === 0
    };
  },
  o = function o(_o, r, e, a, i) {
    var h = t(_o, e);
    if (h.x && h.y) return null;
    var n = r.left - _o.left > _o.right - r.right,
      c = r.left - _o.left < _o.right - r.right,
      f = r.top - _o.top > _o.bottom - r.bottom,
      l = r.top - _o.top < _o.bottom - r.bottom,
      m = a,
      p = i;
    switch (m) {
      case "left":
      case "right":
        h.y || (p = l ? "top" : "bottom");
        break;
      case "up":
      case "down":
        h.x || (p = n ? "right" : "left");
    }
    switch (m) {
      case "left":
        !h.x && n && (m = "right");
        break;
      case "right":
        !h.x && c && (m = "left");
        break;
      case "up":
        !h.y && f && (m = "down");
        break;
      case "down":
        !h.y && l && (m = "up");
    }
    return {
      arrowPosition: p,
      arrowDirection: m
    };
  };
export { o as optimalConfig, t as rectContains };